import React from 'react';
interface FieldProps {
  id: string;
  label: string;
  hint?: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
}
export function Field({
  id,
  label,
  hint,
  error,
  required,
  children
}: FieldProps) {
  return <div data-id="element-376" data-mp="3v73eaobmzb89">
      <label htmlFor={id} className="block text-[14px] font-medium text-ink" data-id="element-377" data-mp="3v7d5ugcbxqg2">
        {label}
        {!required && <span className="ml-1.5 font-normal text-muted" data-id="element-378" data-mp="40aenowhrk5u">optional</span>}
      </label>
      {hint && <p id={`${id}-hint`} className="mt-1 text-small text-muted" data-id="element-379" data-mp="8znbn2h2u7m5">
          {hint}
        </p>}
      <div className="mt-2" data-id="element-380" data-mp="d0p1isp3t7bg">{children}</div>
      {error && <p id={`${id}-error`} role="alert" className="mt-2 text-small text-[#9a2d2d]" data-id="element-381" data-mp="hubgiriqpnaf">
          {error}
        </p>}
    </div>;
}
export const inputClass = 'w-full rounded-sm border border-line bg-white px-3.5 py-2.5 text-[15px] text-ink placeholder:text-muted/70 focus:border-royal';
interface ConsentCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: React.ReactNode;
}
export function ConsentCheckbox({
  id,
  checked,
  onChange,
  children
}: ConsentCheckboxProps) {
  return <div className="flex items-start gap-3" data-id="element-382" data-mp="tepfgqcqhzu7">
      <input id={id} type="checkbox" checked={checked} onChange={event => onChange(event.target.checked)} className="mt-1 h-4 w-4 shrink-0 rounded-[2px] border-line text-royal accent-[#123C73]" data-id="element-383" data-mp="oeb6n63b6lv4" />
      <label htmlFor={id} className="text-[13px] leading-relaxed text-body" data-id="element-384" data-mp="1h3rxhzba5up8">
        {children}
      </label>
    </div>;
}